import { render, staticRenderFns } from "./edit_postprice.vue?vue&type=template&id=b7d97466&scoped=true&"
import script from "./edit_postprice.vue?vue&type=script&lang=js&"
export * from "./edit_postprice.vue?vue&type=script&lang=js&"
import style0 from "./edit_postprice.vue?vue&type=style&index=0&id=b7d97466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d97466",
  null
  
)

export default component.exports